// NPM
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isNil } from 'lodash';

// HELPERS
import { toaster } from 'Helpers/toaster';

// ANT COMPONENTS
import { Space } from 'antd';

// ATOM
import { authActionStatusAtom, authErrorAtom } from 'Recoil/auth.atom';

// SERVICE
import { authBusinessAccountForgetPassword, authForgetPassword } from 'Services/auth.services';

// COMPONENTS
import ForgetPasswordForm from 'Components/auth/forget-password-form';

// STYLE
import './forget-password.scss';

const ForgetPasswordPage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [status, setStatus] = useRecoilState<any>(authActionStatusAtom);
  const [error, setError] = useRecoilState<any>(authErrorAtom);

  const onSubmit = async ({ email, accountType }) => {
    setStatus({ ...status, forgetPassword: 'loading' });
    if (accountType === 'INDIVIDUAL_ACCOUNT') {
      const responseData: any = await authForgetPassword({ email });

      if (!isNil(responseData.error)) {
        setStatus({ ...status, forgetPassword: 'error' });
        setError(responseData?.error);
      }
      else if (responseData.ErrorCode == '0') {
        setStatus({ ...status, forgetPassword: 'error' });
      }
      else if (responseData.ErrorCode == '1') {
        setStatus({ ...status, forgetPassword: 'success' });
      }
    } else if (accountType === 'BUSINESS_ACCOUNT') {
      const responseData: any = await authBusinessAccountForgetPassword({ email });

      if (!isNil(responseData.error)) {
        setError(responseData?.error);
        setStatus({ ...status, forgetPassword: 'error' });
      } else {
        setStatus({ ...status, forgetPassword: 'success' });
      }
    }
  }

  const afterSuccess = () => {
    toaster('success', t('toaster.resetPasswordSuccess'));
    setStatus({ ...status, forgetPassword: 'idle' });
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('pageTitle.forgetPassword')}</title>
        <meta name="robots" content="noindex"/>
      </Helmet>

      <div className="forget-password-page">
        <div className="forget-password-page--main">
          <div className="forget-password-page--container">
            <div className="forget-password-page--form">
              <div className="forget-password-page--form-title">{t('title.forgetPassword')}</div>
              <Space direction="vertical" size="middle" className="center">
                <div className="mb-50" dangerouslySetInnerHTML={{ __html: t('txt.forgetPassword') }} />
              </Space>

                <ForgetPasswordForm
                  status={status.forgetPassword}
                  onSubmit={onSubmit}
                  afterSuccess={afterSuccess}
                />
              </div>
              <div className="forget-password-page--bot"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ForgetPasswordPage
